export const NAV_ITEMS = [
  { id: 'home', label: 'गृहपृष्ठ', path: '/' },
  { id: 'news', label: 'समाचार', path: '/news' },
  { id: 'samaj', label: 'समाज', path: '/samaj' },
  { id: 'rajniti', label: 'राजनीति', path: '/rajniti' },
  { id: 'bichar', label: 'विचार', path: '/bichar' },
  { id: 'khelkud', label: 'खेलकुद', path: '/khelkud' },
  { id: 'vividh', label: 'विविध', path: '/vividh' },
  { id: 'calendar', label: 'पात्रो', path: '/calendar' },
  { id: 'unicode', label: 'युनिकोड', path: '/unicode' },
];

export const NAV_PATH = Object.fromEntries(NAV_ITEMS.map((n) => [n.id, n.path]));

export const CATEGORY_COLOR = {
  politics: '#2457A8',
  economy: '#B9812E',
  sports: '#1F7A4D',
  entertainment: '#8B3FA6',
  world: '#2457A8',
  tech: '#0E7C86',
  opinion: '#6B7280',
  samaj: '#8B3FA6',
  vividh: '#6B7280',
};

export const CATEGORY_LABEL = {
  politics: 'राजनीति',
  economy: 'अर्थतन्त्र',
  sports: 'खेलकुद',
  entertainment: 'मनोरञ्जन',
  world: 'विश्व',
  tech: 'प्रविधि',
  opinion: 'विचार',
  samaj: 'समाज',
  vividh: 'विविध',
};
